export const environment = {

  production: true,
  environmentType: 'stg',

  web: {
    baseUrl: '//studio.stg.mtm.video',
    avatarUrl: 'https://gateway.studio.stg.mtm.video/api/public-images/USER/AVATAR/%USERNAME%',
  },

  api: {
    baseUrl: 'https://gateway.studio.stg.mtm.video',
    mockapiUrl: '//58c14598e8215412002f7cf5.mockapi.io',
    analyticsUrl: 'https://analytics.studio.stg.mtm.video'
  },

  adminConsole: {
    baseUrl: 'https://platform.studio.stg.mtm.video',
    authPath: '/auth/sso-callback'
  },

  adminStudio: {
    baseUrl: 'https://admin.studio.stg.mtm.video',
  },

  websocket: {
    chatBaseUrl: 'https://gateway.studio.stg.mtm.video/chat'
  },

  versionCheckURL: 'https://studio.stg.mtm.video/version.json',
  healthCheckURL: 'https://gateway.studio.stg.mtm.video/mtm-manage/health',
  captchaSiteKey: '6Leo1FosAAAAADzpLT93crA7wP7kUOHuN85zpCYF',
  sentry: {
    dsn: 'https://cc5da55be645245f9daca78ca30f6072@o4508692085145600.ingest.de.sentry.io/4508692413808720',
    enabled: false,
  },
	userflow: {
		token: 'userflow-token',
		enabled: false,
	},
  iam: {
    iamApiUrl: 'https://iam.studio.stg.mtm.video',
    appApiUrl: 'https://gateway.studio.stg.mtm.video',
    ssoCallbackUrl: '/sso/callback',
    ssoCallbackHost: 'https://studio.stg.mtm.video',
    authProcessUrl: '/entry/auth/process',
    resetPasswordCallbackUrl: '/entry/auth/reset',
    serviceUuid: '00e9b227-eb3a-4d96-bc68-5f0027cb785a',
    ssoUrl: {
      google: 'https://gateway.studio.stg.mtm.video/oauth2/authorization/google',
      azure: 'https://gateway.studio.stg.mtm.video/oauth2/authorization/azure',
    },
  },

  drive: {
    apiUrl: 'https://drive.svc.studio.stg.mtm.video',
  },

  admin: {
    apiUrl: 'https://admin.gtw.studio.stg.mtm.video/gtw',
  },

  context: {
    apiUrl: 'https://context.studio.stg.mtm.video',
  },
};
